import { ErrorTriageState } from '@common/interfaces/errorTriage'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'
import {
  IErrorOccurrenceListQuery,
  IErrorTriageListQuery,
  IListOptions,
  IPageParams,
} from './helpers'

export const prefix = 'errorTriage'

export const [LIST_ERROR_TRIAGE_REQUEST, LIST_ERROR_TRIAGE_SUCCESS, LIST_ERROR_TRIAGE_FAILURE] =
  createRequestTypes(prefix, 'LIST_ERROR_TRIAGE')

export const [SHOW_ERROR_TRIAGE_REQUEST, SHOW_ERROR_TRIAGE_SUCCESS, SHOW_ERROR_TRIAGE_FAILURE] =
  createRequestTypes(prefix, 'SHOW_ERROR_TRIAGE')

export const [
  UPDATE_ERROR_TRIAGE_STATE_REQUEST,
  UPDATE_ERROR_TRIAGE_STATE_SUCCESS,
  UPDATE_ERROR_TRIAGE_STATE_FAILURE,
] = createRequestTypes(prefix, 'UPDATE_ERROR_TRIAGE_STATE')

export const [
  AUTO_FIX_ERROR_TRIAGE_REQUEST,
  AUTO_FIX_ERROR_TRIAGE_SUCCESS,
  AUTO_FIX_ERROR_TRIAGE_FAILURE,
] = createRequestTypes(prefix, 'AUTO_FIX_ERROR_TRIAGE')

export const [
  INVESTIGATE_ERROR_TRIAGE_REQUEST,
  INVESTIGATE_ERROR_TRIAGE_SUCCESS,
  INVESTIGATE_ERROR_TRIAGE_FAILURE,
] = createRequestTypes(prefix, 'INVESTIGATE_ERROR_TRIAGE')

export const RESET_ERROR_TRIAGE_DETAIL = `${prefix}/RESET_ERROR_TRIAGE_DETAIL`

export const [
  LIST_ERROR_OCCURRENCES_REQUEST,
  LIST_ERROR_OCCURRENCES_SUCCESS,
  LIST_ERROR_OCCURRENCES_FAILURE,
] = createRequestTypes(prefix, 'LIST_ERROR_OCCURRENCES')

export const [
  LIST_ERROR_TRIAGE_OCCURRENCES_REQUEST,
  LIST_ERROR_TRIAGE_OCCURRENCES_SUCCESS,
  LIST_ERROR_TRIAGE_OCCURRENCES_FAILURE,
] = createRequestTypes(prefix, 'LIST_ERROR_TRIAGE_OCCURRENCES')

export const listErrorTriage = createAction(
  (query: IErrorTriageListQuery & IPageParams, options?: IListOptions) => ({
    type: [LIST_ERROR_TRIAGE_REQUEST, LIST_ERROR_TRIAGE_SUCCESS, LIST_ERROR_TRIAGE_FAILURE] as [
      string,
      string,
      string,
    ],
    promise: (api: IApi) => api.errorTriage.list(query),
    params: { ...query, ...options },
  }),
)

/** The Live tab: every error's occurrences. */
export const listErrorOccurrences = createAction(
  (query: IErrorOccurrenceListQuery & IPageParams, options?: IListOptions) => ({
    type: [
      LIST_ERROR_OCCURRENCES_REQUEST,
      LIST_ERROR_OCCURRENCES_SUCCESS,
      LIST_ERROR_OCCURRENCES_FAILURE,
    ] as [string, string, string],
    promise: (api: IApi) => api.errorTriage.listOccurrences(query),
    params: { ...query, ...options },
  }),
)

/** The drawer: one error's occurrences. */
export const listErrorTriageOccurrences = createAction(
  (
    {
      errorTriageId,
      ...query
    }: IErrorOccurrenceListQuery & IPageParams & { errorTriageId: string },
    options?: IListOptions,
  ) => ({
    type: [
      LIST_ERROR_TRIAGE_OCCURRENCES_REQUEST,
      LIST_ERROR_TRIAGE_OCCURRENCES_SUCCESS,
      LIST_ERROR_TRIAGE_OCCURRENCES_FAILURE,
    ] as [string, string, string],
    promise: (api: IApi) => api.errorTriage.listTriageOccurrences(errorTriageId, query),
    params: { ...query, errorTriageId, ...options },
  }),
)

export const showErrorTriage = createAction((id: string, options?: { skipLoader?: boolean }) => ({
  type: [SHOW_ERROR_TRIAGE_REQUEST, SHOW_ERROR_TRIAGE_SUCCESS, SHOW_ERROR_TRIAGE_FAILURE] as [
    string,
    string,
    string,
  ],
  promise: (api: IApi) => api.errorTriage.show(id),
  params: { id, ...options },
}))

export const updateErrorTriageState = createAction((id: string, state: ErrorTriageState) => ({
  type: [
    UPDATE_ERROR_TRIAGE_STATE_REQUEST,
    UPDATE_ERROR_TRIAGE_STATE_SUCCESS,
    UPDATE_ERROR_TRIAGE_STATE_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.errorTriage.updateState(id, state),
  params: { id, state },
}))

export const autoFixErrorTriage = createAction((id: string) => ({
  type: [
    AUTO_FIX_ERROR_TRIAGE_REQUEST,
    AUTO_FIX_ERROR_TRIAGE_SUCCESS,
    AUTO_FIX_ERROR_TRIAGE_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.errorTriage.autoFix(id),
  params: { id },
}))

export const investigateErrorTriage = createAction((id: string) => ({
  type: [
    INVESTIGATE_ERROR_TRIAGE_REQUEST,
    INVESTIGATE_ERROR_TRIAGE_SUCCESS,
    INVESTIGATE_ERROR_TRIAGE_FAILURE,
  ] as [string, string, string],
  promise: (api: IApi) => api.errorTriage.investigate(id),
  params: { id },
}))

export const resetErrorTriageDetail = () => ({
  type: RESET_ERROR_TRIAGE_DETAIL,
})
